import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  isAndroid,
  isChrome,
  isIOS,
  isMobileSafari,
  isSafari
} from 'react-device-detect'
import {
  DeviceDetectWrapper
} from './styled'

export class DeviceDetect extends React.PureComponent {
  render () {
    const {
      className,
      children
    } = this.props

    // props for css classes

    return (
      <DeviceDetectWrapper
        className={ClassNames(
          'device-detect-container',
          {'is-android': isAndroid },
          {'is-ios': isIOS },
          {'is-chrome': isChrome },
          {'is-safari': isSafari },
          {'is-mobile-safari': isMobileSafari },
          className
        )}
      >
        {children}
      </DeviceDetectWrapper>
    )
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
 
    className: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ]),

    isAndroid: PropTypes.bool,

    isIOS: PropTypes.bool,

    isChrome: PropTypes.bool,

    isSafari: PropTypes.bool,

    isMobileSafari: PropTypes.bool
  }
}
